import fields from "./fields.utils.js";

const schema_travel = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,
        placeholder: 'Date of Birth'
    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "has_medical_conditions": {
        label: "Has medical conditions",
        value: true,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "cover_duration": {
        label: 'Cover Duration',
        type: 'select',
        value: '',
        options: [],
        required: true,

    },
    'travel_type': {
        label: 'Travel Type',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    'destination': {
        label: 'Travel Destination',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    'travel_estimated_time': {
        label: 'Estimated travel time (in days)',
        type: 'number',
        value: '',
        placeholder: '1,2,3...',
        required: true,
    },
    'hazardous_activities': {
        label: "risky activities",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    'traveller_x_date_of_birth': {
        label: "Date of birth",
        type: 'date-mask',
        value: '',
        placeholder: 'Date of Birth'
    },
    'traveller_x_name': {
        label: "Name",
        value: '',
        type: 'text',

        placeholder: 'Name'
    },
    'medical_condition_x_type': {
        type: 'text',
        label: 'medical condition',
        value: '',
        required: true
    },
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_travel;
